import ValidationRules from '../Data/ValidationRules';
import moment from 'moment';

module.exports = {
    validate: function(fieldName, inputValue) {
        let validationRules = ValidationRules;
        let result = validationRules.map((validationRulesJson) => {
            let _this = this;
            let allErrorMessages = [];
            let validationResult = _this.success();
            $.map(validationRulesJson[fieldName], function(validationParamAndErrorMessage, validationMethod) {
                let validationResult = _this[validationMethod](inputValue, validationParamAndErrorMessage);
                if (validationResult.errors && validationResult.errors.length > 0) {
                    for (let i = 0; i < validationResult.errors.length; i++) {
                        allErrorMessages.push(validationResult.errors[i]);
                    }
                }
            });
            if (allErrorMessages && allErrorMessages.length > 0) {
                return {
                    isValid: false,
                    hasError: true,
                    errors: allErrorMessages
                };
            } else {
                return validationResult;
            }
        });
        return result;
    },

    success: function() {
        return {
            isValid: true,
            hasError: false,
        };
    },

    failure: function(errorMessage) {
        let errorArray = [];
        if (errorMessage) {
            errorArray.push(errorMessage);
        }
        return {
            isValid: false,
            hasError: true,
            isHelpVisible: false,
            errors: errorArray,
        };
    },

    minimum: function(inputValue, validationValues) {
        if (! inputValue || validationValues['value'] > parseInt(inputValue)) {
            return this.failure(validationValues['error']);
        } else {
            return this.success();
        }
    },

    maximum: function(inputValue, validationValues) {
        if (! inputValue || validationValues['value'] < parseInt(inputValue)) {
            return this.failure(validationValues['error']);
        } else {
            return this.success();
        }
    },

    not_null: function(inputValue, validationValues) {
        if (! inputValue || inputValue == null) {
            return this.failure(validationValues['error']);
        } else {
            return this.success();
        }
    },

    not_zero: function(inputValue, validationValues) {
        if (! inputValue || inputValue == 0) {
            return this.failure(validationValues['error']);
        } else {
            return this.success();
        }
    },

    too_young: function(inputValue, validationValues) {
        if (moment(inputValue).isAfter(validationValues['value'])) {
            return this.failure(validationValues['error']);
        } else {
            return this.success();
        }
    },

    too_old: function(inputValue, validationValues) {
        if (moment(inputValue).isBefore(validationValues['value'])) {
            return this.failure(validationValues['error']);
        } else {
            return this.success();
        }
    },

    min_length: function(inputValue, validationValues) {
        if (! inputValue || validationValues['value'] > inputValue.length) {
            return this.failure(validationValues['error']);
        } else {
            return this.success();
        }
    },

    max_length: function(inputValue, validationValues) {
        if (! inputValue || validationValues['value'] < inputValue.length) {
            return this.failure(validationValues['error']);
        } else {
            return this.success();
        }
    },

    length_between: function(inputValue, validationValues) {
        if (! inputValue || (validationValues['value'][0] > inputValue.length || validationValues['value'][1] < inputValue.length)) {
            return this.failure(validationValues['error']);
        } else {
            return this.success();
        }
    },

    regex_check: function(inputValue, validationValues) {
        if (validationValues['value'].test(inputValue)) {
            return this.success();
        } else {
            return this.failure(validationValues['error']);
        }
    },

    not_equal: function(inputValue, validationValues) {
        if (inputValue == validationValues['value']) {
            return this.failure(validationValues['error']);
        } else {
            return this.success();
        }
    },
};



/** WEBPACK FOOTER **
 ** ./src/components/Managers/Validation.js
 **/